const EventEmitter = require('events').EventEmitter
var moment = require('moment')
moment.locale('it')
import axios from './tAxios'
import storage from './tStorage'

import dbItem from './dbItem'


class socio{
   constructor (args) {
      this.event = new EventEmitter()
      this.moment = moment
      this.societa = 1700
      this.sigla = 'SINP'
      this.primoanno = 2021
      this.contatto = new dbItem({database:'bm_iscrizionisoc',table:'schedasinp'})
      this._si = []
      this._versamento = []

      this.contatto.event.on('loaded', () =>{
         storage.save('socio',this.contatto.row.id)
         //this.init()         
      })
      
      return this
   }

   getSi(){
      axios.query('fetchOne',`SELECT id FROM statoiscrizione WHERE contatto=→id AND societa=→societa ORDER BY id`,{id: this.contatto.row.id, societa: this.societa}).then((response) =>  {
         this.si.load(response.result)
      })
   }

   getStatoiscrizione(){
      axios.query('fetchAll',`SELECT * FROM statoiscrizione WHERE contatto=→id  ORDER BY id`,{id: this.contatto.row.id, societa: this.societa},this,'_si')
   }
   
   getRrinnovi(){
      axios.query('fetchAll',`SELECT * FROM rinnovo WHERE contatto=→id ORDER BY societa,anno DESC`,{id: this.contatto.row.id},this,'_rinnovo')
   }
   
   getVersamenti(){
      axios.query('fetchAll',`SELECT * FROM versamento WHERE contatto=→id ORDER BY eseguitoil DESC`,{id: this.contatto.row.id},this,'_versamento')
   }

   getNextquote(){
      axios.query('fetchAll',`call next_quote(→id,→sezione,'summary')`,{id: this.contatto.row.id,sezione:this.societa/100},this,'_nextquote')
   }

   getNextquoteDetail(){
      axios.query('fetchAll',`call next_quote(→id,→sezione,'detail')`,{id: this.contatto.row.id,sezione:this.societa/100},this,'_nextquoteDetail')
   }


   async init(){
      await axios.query('query',`UPDATE statoiscrizione SET dbaction=1 WHERE dbaction=-1;`)
      return new Promise(async (resolve, reject) => {
         
         await this.getSi()
         await this.getNextquote()
         await this.getNextquoteDetail()
         await this.getRrinnovi()
         await this.getVersamenti()
         await this.getStatoiscrizione()
         resolve("Fatto")
      })
   }

   checkEmail(emailCheck){
      return new Promise((resolve, reject) => {
         axios.query('fetchOne',`SELECT email FROM bm_iscrizionisoc.schedasinp WHERE email=→email AND step>1 LIMIT 1`,{email:emailCheck}).then((response) => {
          var controllo = (response.result == emailCheck) ? false : true
          resolve(controllo)
        })
      })
   }

   checkEmailLimmsy(emailCheck){
      return new Promise((resolve, reject) => {
         axios.query('fetchOne',`SELECT email FROM bm_limmsy.contatto AS cnt LEFT JOIN bm_limmsy_sinp.statoiscrizione AS si ON si.contatto=cnt.id AND si.societa=←societa WHERE email=→email AND si.id IS NOT NULL LIMIT 1`,{societa:this.societa,email:emailCheck}).then((response) => {
          var controllo = (response.result == emailCheck) ? false : true
          resolve(controllo)
        })
      })
   }

   checkCodicefiscale(codicefiscaleCheck){
      return new Promise((resolve, reject) => {
         axios.query('fetchOne',`SELECT cf FROM bm_iscrizionisoc.schedasinp WHERE cf=→codicefiscale AND step>1 LIMIT 1`,{codicefiscale:codicefiscaleCheck}).then((response) => {
          var controllo = (response.result == codicefiscaleCheck) ? false : true
          resolve(controllo)
        })
      })
   }

   checkCodicefiscaleLimmsy(codicefiscaleCheck){
      return new Promise((resolve, reject) => {
         axios.query('fetchOne',`SELECT codicefiscale FROM bm_limmsy.contatto AS cnt LEFT JOIN bm_limmsy_sinp.statoiscrizione AS si ON si.contatto=cnt.id AND si.societa=←societa WHERE codicefiscale=→codicefiscale AND si.id IS NOT NULL LIMIT 1`,{societa:this.societa,codicefiscale:codicefiscaleCheck}).then((response) => {
          var controllo = (response.result == codicefiscaleCheck) ? false : true
          resolve(controllo)
        })
      })
   }

}
export default new socio
